import { router } from '@/main';
import { ToastsService } from '@/utils';

interface CustomError {
  key: number;
  messages: string[];
}

enum HttpMethod {
  'GET',
  'POST',
  'PUT',
  'DELETE',
}

let apiVersion: string | null = null;

export async function request(url: string, requestObject: RequestInit): Promise<any> {
  requestObject.headers = {
    ...requestObject.headers,
    'X-VERSION-ID' : apiVersion ?? process.env.VUE_APP_VERSION,
  } as HeadersInit;

  const response = await fetch(url, requestObject);

  apiVersion = response.headers.get('X-API-VERSION') ?? '';

  if (!response.ok) {
    handleError(response, requestObject.method);
    return Promise.reject(response);
  }

  return Promise.resolve(response);
}

async function handleError(response: Response, method: string | undefined) {
  switch (response.status) {
    case 400:
      displayErrorToast(response);
      break;

    case 403:
      router.push({ name: 'error-page', params: { errorMessageKey: 'forbidden' } });
      break;

    case 404:
      if (method === HttpMethod[HttpMethod.GET]) {
        router.push({ name: 'error-page', params: { errorMessageKey: 'not-found' } });
      } else {
        displayErrorToast(response);
      }
      break;

    case 409:
      displayErrorToast(response);
      break;

    case 500:
      router.push({ name: 'error-page', params: { errorMessageKey: 'server-error' } });
      break;

    default:
      ToastsService.error('Error: ' + router.app.$t('errors.undefined'));
  }
}

async function displayErrorToast(response: Response) {
  const data = await response.json();
  data.forEach((error: CustomError) => {
    error.messages.forEach(m => {
      ToastsService.error('Error: ' + router.app.$t(`errors.${m}`));
    });
  });
}

